import { render, staticRenderFns } from "./listOfPartners.vue?vue&type=template&id=e2b94cde"
import script from "./listOfPartners.vue?vue&type=script&lang=js"
export * from "./listOfPartners.vue?vue&type=script&lang=js"
import style0 from "./listOfPartners.vue?vue&type=style&index=0&id=e2b94cde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports